module.exports = __webpack_public_path__ + "img/f15.94c5a691.jpg";